interface ChevronDownIconProps {
  color?: string;
}

export const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({ color = 'black' }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 5L8 11.5L2 5" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" />
    </svg>
  );
};
